module.exports = __webpack_public_path__ + "static/Telltale-27d0a1d29850527754d8e166570b6257.png";